import { useCallback } from 'react'

import { apiUrl, useApiRequest } from '../useApiRequest'

import { RefundPoint, RefundPointSummary } from '../../types/refundPoint/refundPoint'

export function useRefundPoints() {
  const { run, loading, error, resetState } = useApiRequest()

  const mine = useCallback(
    () => run(({ fetcher }) => fetcher<RefundPoint[]>(apiUrl('/refund-points'))),
    [run]
  )

  const summary = useCallback(
    () => run(({ fetcher }) => fetcher<RefundPointSummary>(apiUrl('/refund-points/summary'))),
    [run]
  )

  /** Balance of a customer a manager books for. */
  const summaryOfProfile = useCallback(
    (profileId: string | number) =>
      run(({ fetcher }) =>
        fetcher<RefundPointSummary>(apiUrl(`/profiles/${profileId}/refund-points/summary`))
      ),
    [run]
  )

  return { mine, summary, summaryOfProfile, loading, error, resetState }
}
